import { types } from 'mobx-state-tree';

import DateTime from '@utils/mst/types/DateTime';

const BenefitTag = types
  .model('BenefitTag', {
    id: types.identifierNumber,
    name: types.string,
    createdAt: DateTime,
    updatedAt: types.maybeNull(DateTime),
    deletedAt: types.maybeNull(DateTime),
  });

export default BenefitTag;
